import { PARENT_ENTITY_ID } from '@/modules/corporate/modules/exercise/views/Details/utils';

import { PARENT_ROUTE as ADMIN_PARENT_ROUTE } from '../admin';

const PARENT_ROUTE = '/roleplay';
const ADMIN_ROLEPLAY_PARENT_ROUTE = `${ADMIN_PARENT_ROUTE}${PARENT_ROUTE}`;

const adminRoleplayRoutes = {
  AdminRoleplayDetails: (roleplayId: string) =>
    `${ADMIN_ROLEPLAY_PARENT_ROUTE}/${roleplayId}/details`,
  AdminRoleplayReports: (roleplayId: string) =>
    `${ADMIN_ROLEPLAY_PARENT_ROUTE}/${roleplayId}/reports`,
  RoleplayEditor: (roleplayId: string) => `${ADMIN_ROLEPLAY_PARENT_ROUTE}/${roleplayId}/edit`,
};

const learnerRoleplayRoutes = {
  RoleplayDetails: (roleplayId: string) => `${PARENT_ROUTE}/${roleplayId}/details`,
};

const courseRoleplayRoutes = {
  CourseRoleplayDetails: (roleplayId: string, courseId: string) =>
    `${PARENT_ROUTE}/${roleplayId}/details?${PARENT_ENTITY_ID}=${courseId}`,
};
export const roleplayDetailRoute = (roleplayId: string) => ({
  admin: adminRoleplayRoutes.AdminRoleplayDetails(roleplayId),
  learner: learnerRoleplayRoutes.RoleplayDetails(roleplayId),
});

const routes = {
  ...adminRoleplayRoutes,
  ...learnerRoleplayRoutes,
  ...courseRoleplayRoutes,
};

export const ADMIN_ROLEPLAY_ROUTE_KEYS = {
  AdminRoleplayDetails: 'AdminRoleplayDetails',
  RoleplayEditor: 'RoleplayDetails',
};

export const LEARNER_ROLEPLAY_ROUTE_KEYS = {
  RoleplayDetails: 'RoleplayDetails',
  CourseRoleplayDetails: 'CourseRoleplayDetails',
};

export const ROLEPLAY_ROUTE_KEYS = {
  ...ADMIN_ROLEPLAY_ROUTE_KEYS,
  ...LEARNER_ROLEPLAY_ROUTE_KEYS,
};

export default routes;
